module.exports = __webpack_public_path__ + "static/media/magassag.a04fdc2c.png";